import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import React from "react";

export const LoadingView = () => (
  <div
    className={"flex flex-1 flex-col justify-center items-center border-gray-100 border-2 h-[calc(100%)] gap-y-6"}
  >
    <FontAwesomeIcon icon={faSpinner} spin className={"text-9xl text-gray-300"} />
    <div className={"text-3xl text-gray-500"}>
      載入中
    </div>
  </div>
)